import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import { ImportService } from '../../services';
import {Compbaser} from "../compbaser/compbases";

interface IDialogImporting {
    showCancel?: boolean;
    showProgress?: boolean;
}
@Component({
    selector: 'app-dialog-importing',
    templateUrl: './dialog-importing.component.html',
    styleUrls: ['./dialog-importing.component.scss']
})
export class DialogImportingComponent extends Compbaser implements OnInit {

    showCancel = false;
    showProgress = false;
    downloadingItem = 'downloading...';
    
    constructor(
        private importService: ImportService,
        public dialogRef: MatDialogRef<any>, 
        @Inject(MAT_DIALOG_DATA) public data: IDialogImporting) {
        super();
        this.showCancel = !!data.showCancel;
        this.showProgress = !!data.showProgress;
    }

    ngOnInit(): void {
        if (this.showProgress) {
            this.cod(
                this.importService.progress$.subscribe(downloadingItem => {
                    this.downloadingItem = String(downloadingItem);
                })
            );
        }
    }

    closeImporting() {
        this.dialogRef.close();
    }
}


